import { render } from "./DictionaryPlaceForm.vue?vue&type=template&id=7266648a"
import script from "./DictionaryPlaceForm.vue?vue&type=script&lang=js"
export * from "./DictionaryPlaceForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__